/**
 * Options, para usar o método de modificação da máscara
 */
const spOptions = {
  onKeyPress: function(val, e, field, options) {
    field.mask(SPMaskBehavior.apply({}, arguments), options);
  }
};

/**
 * Método para determinar se a máscara deve ser modificada
 * de acordo com a quantidade de dígitos do telefone
 * @param {string} val
 */
const SPMaskBehavior = function(val) {
  const tamanhoMascara =  val.replace(/\D/g, '').length;
  switch(tamanhoMascara) {
    case 12:
      return '55 (00) 0000-00009';
    default:
      return '55 (00) 00000-0000';
  }
};

/**
 * Países que serão exibido primeiro na lista
 * de telefones internacionais
 */
const preferredCountries = [
  'br', 'au','us', 'gb', 'ca', 'ar', 'bo', 'cl', 'py', 'uy',
];

/**
 * Funcão principal do telefone internacional
 * faz a inicialização da input
 */
function InternationalPhone() {
  const inputs = document.querySelectorAll('[data-phone]');

  if (!inputs.length) {
    return;
  }

  window.intlTelInputGlobals.loadUtils('/plugins/intl-tel-input-16.0.2/js/utils.js');
  initializePhoneNumbers(inputs);
}

/**
 * Inicializando as inputs de telefones
 *
 * @param {NodeList} inputs
 */
function initializePhoneNumbers(inputs) {
  inputs.forEach(input => {
    window.intlTelInput(input, {
      initialCountry: 'auto',
      placeholderNumberType: 'FIXED_LINE_OR_MOBILE',
      preferredCountries: preferredCountries,
      customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
        applyMaskInput(input, selectedCountryData.iso2);
        return `${selectedCountryData.dialCode} ${selectedCountryPlaceholder}`;
      },
    });

    setInitialCountry(input);
    addEventListener(input);
  });
}

/**
 * Setar o valor inicial da input de telefone, este
 * método será dispardo apenas no momento em que a input
 * e usa o ip para determinar qual país o usuário está
 * e qual tipo de telefone usar
 *
 * @param {Element} input
 */
function setInitialCountry(input) {
  const data = getRequest();
  const iti = window.intlTelInputGlobals.getInstance(input);

  iti.setCountry(data.country.toLowerCase());
  const countryData = iti.getSelectedCountryData();
  addKeyUpListener(input, countryData.dialCode);

  if(input.value.length > 0){
    input.value = input.value;
    return;
  }

  if (data === undefined) {
    iti.setCountry('br');
    input.value = '55';
    return;
  }

  input.value = countryData.dialCode;
}

/**
 * Adicionar o event listener de modificação de valor
 * na input de telefone
 *
 * @param {Element} input
 */
function addEventListener(input) {
  input.addEventListener('countrychange', function() {
    const iti = window.intlTelInputGlobals.getInstance(input);
    const countryData = iti.getSelectedCountryData();
    const oldIso = input.dataset.iso;

    if (oldIso === countryData.iso2) {
      return;
    }

    applyMaskInput(input, countryData.iso2);
    input.dataset.iso = countryData.iso2;
    input.value = `${countryData.dialCode}`;
  });
}

function addKeyUpListener(input, countryCode){
  input.addEventListener('keydown', event => {
    if(keyUpHelper(event.code) && input.value.length === countryCode.length){
      event.preventDefault();
    }
  })
}

function keyUpHelper(keyUp){
  if(keyUp === 'Backspace' || keyUp === 'KeyX' || keyUp === 'Delete'){
    return true;
  }
  return false;
}

/**
 * Aplicar máscara para a input de telefone, de acordo
 * com o valor de placeholder que a input possui
 *
 * @param {Element} input
 * @param {string} iso
 */
function applyMaskInput(input, iso = null) {
  const mask = input.placeholder.replace(/[0-9]/g, 0);

  if (iso === 'br') {
    return $(input).mask(SPMaskBehavior, spOptions);
  }

  $(input).mask(`${mask}`);
}

/**
 * Enviar request para obter os dados da localização do
 * usuário de acordo com o ip dele, e definir qual máscara
 * exibir inicialmente
 */
function getRequest() {
  let data;

  $.ajax({
    url: 'https://ipinfo.io/json',
    method: 'GET',
    async: false
  })
  .done((response) => {
    data = response;
  })
  .fail((error) => {
    console.log('error: ', error);
    data = undefined;
  })

  return data;
}

exports.init = InternationalPhone;
